import React from "react";

import DateTimeService from "../../../../utils/dateTimeService";
import { main_url } from "../../../../utils/CommonFunction";

import EmploymentFormContainer from "./components/EmploymentFormContainer";
import EmploymentDetailFormTitle from "./components/EmploymentDetailFormTitle";
import EmployeeDetailItemsContainer from "./components/EmployeeDetailItemsContainer";
import EmploymentDetailItemTextBox from "./components/EmploymentDetailItemTextBox";
import TheButton from "./components/TheButton";
import ButtonsContainer from "./components/ButtonsContainer";
import RegionField from "./RegionField";

const EmploymentDetailView = (props) => {
  const {
    user_id,
    selectedEmployeeId,
    selected_exit_status,
    selected_disCon_status,
    selected_job,
    salaryList,
    career_level,
    career_sub_level,
    transactionType,
    employeeName,
    handleFormCancel,
    resignReason,
    disconDate,
    effectiveDate,
    salary,
    selected_branch,
    departmentlist,
    selected_designation,
    actualDate,
    selected_status,
    employedDate,
    salaryPermission,
    attachment,
    remark,
    demotionReason,
    monitoringEndDate,
    lastWorkingDate,
  } = props;

  // Department
  let department;
  if (selected_designation != null) {
    department = departmentlist.find(
      (v) => v.departments_id === selected_designation.departments_id
    );
  }

  // EmployeeName
  let name = employeeName ?? "";

  // Salary
  let salaryInputFieldValue = salary;
  if (!salaryInputFieldValue && career_sub_level) {
    const salaryInfo = salaryList.find(
      (v) => v.career_sub_level === career_sub_level.career_sub_level_id
    );
    if (salaryInfo) {
      salaryInputFieldValue = salaryInfo.basic_salary;
    }
  }

  const canViewSalary =
    salaryPermission.length > 0 ||
    (career_sub_level ? career_sub_level.career_level_id : null) <= 6;

  return (
    <form>
      <EmploymentFormContainer>
        <EmploymentDetailFormTitle />
        <EmployeeDetailItemsContainer>
          <div className="col-lg-5 col-md-12 col-sm-12">
            <EmploymentDetailItemTextBox
              label="Transaction Type"
              value={transactionType?.label ?? ""}
            />
            <EmploymentDetailItemTextBox
              label="Employee Code"
              value={!selectedEmployeeId ? null : selectedEmployeeId.label}
            />
            <EmploymentDetailItemTextBox
              label="Employee Name"
              value={!name ? null : name.toUpperCase()}
            />
            <EmploymentDetailItemTextBox
              label="Employee Status"
              value={!selected_status ? null : selected_status.label}
            />
            <EmploymentDetailItemTextBox
              label="Designation"
              value={!selected_designation ? null : selected_designation.label}
            />
            <EmploymentDetailItemTextBox
              label="Branch"
              value={
                !selected_branch || selected_branch.length <= 0
                  ? null
                  : selected_branch[0].label
              }
            />
            <EmploymentDetailItemTextBox
              label="Department"
              value={!department ? null : department.label}
            />
            <RegionField
              isView={true}
              branchId={
                !selected_branch || selected_branch.length <= 0
                  ? null
                  : selected_branch[0].value
              }
            />
            <EmploymentDetailItemTextBox
              label="Career Level"
              value={!career_level ? null : career_level.label}
            />
            <EmploymentDetailItemTextBox
              label="Career Sub Level"
              value={!career_sub_level ? null : career_sub_level.label}
            />
            <EmploymentDetailItemTextBox
              label="Date"
              value={new DateTimeService().todayDate}
            />
            <EmploymentDetailItemTextBox label="Remark" value={remark} />
            {/* eslint-disable */}
            {/* This canViewSalary check is for layout, not for logic! */}
            {canViewSalary && attachment && (
              <a
                href={`${main_url}employee/getCRDocumentData/${user_id}/${attachment}`}
                download
                target="_blank"
                style={{
                  color: "#7D7D7D",
                  fontSize: 14,
                }}
              >
                <EmploymentDetailItemTextBox
                  label="Attachment"
                  value={!attachment ? null : attachment.split("&@")[1]}
                />
              </a>
            )}
            {/* eslint-enable */}
            {canViewSalary && !attachment && (
              <EmploymentDetailItemTextBox
                label="Attachment"
                value={!attachment ? null : attachment.split("&@")[1]}
              />
            )}
          </div>
          <div className="col-lg-5 col-md-12 col-sm-12">
            <EmploymentDetailItemTextBox
              label="Employed Date"
              value={new DateTimeService(employedDate).formatDate}
            />
            <EmploymentDetailItemTextBox
              label="Effective Date"
              value={new DateTimeService(effectiveDate).formatDate}
            />
            <EmploymentDetailItemTextBox
              label="Arrival Date"
              value={new DateTimeService(actualDate).formatDate}
            />
            <EmploymentDetailItemTextBox
              label="Job Title"
              value={!selected_job ? null : selected_job.label}
            />
            {canViewSalary && (
              <EmploymentDetailItemTextBox
                label="Salary"
                value={salaryInputFieldValue}
              />
            )}
            <EmploymentDetailItemTextBox
              label="Reason of Demotion"
              value={
                !demotionReason ? null : demotionReason.demotion_reason_name
              }
            />
            <EmploymentDetailItemTextBox
              label="End of Monitoring Date"
              value={new DateTimeService(monitoringEndDate).formatDate}
            />
            <EmploymentDetailItemTextBox
              label="Last Working Date"
              value={new DateTimeService(lastWorkingDate).formatDate}
            />
            <EmploymentDetailItemTextBox
              label="Discontinuous Status"
              value={
                !selected_disCon_status ? null : selected_disCon_status.label
              }
            />
            <EmploymentDetailItemTextBox
              label="Discontinuous Date"
              value={new DateTimeService(disconDate).formatDate}
            />
            <EmploymentDetailItemTextBox
              label="Exit Status"
              value={!selected_exit_status ? null : selected_exit_status.label}
            />
            <EmploymentDetailItemTextBox
              label="Resign Reason"
              value={resignReason}
            />
            {/* eslint-disable */}
            {/* This canViewSalary check is for layout, not for logic! */}
            {!canViewSalary && attachment && (
              <a
                href={`${main_url}employee/getCRDocumentData/${user_id}/${attachment}`}
                download
                target="_blank"
                style={{
                  color: "#7D7D7D",
                  fontSize: 14,
                }}
              >
                <EmploymentDetailItemTextBox
                  label="Attachment"
                  value={!attachment ? null : attachment.split("&@")[1]}
                />
              </a>
            )}
            {/* eslint-enable */}
            {!canViewSalary && !attachment && (
              <EmploymentDetailItemTextBox
                label="Attachment"
                value={!attachment ? null : attachment.split("&@")[1]}
              />
            )}
          </div>
        </EmployeeDetailItemsContainer>

        <ButtonsContainer>
          <TheButton onClick={handleFormCancel} label="Back" />
        </ButtonsContainer>
      </EmploymentFormContainer>
    </form>
  );
};

export default EmploymentDetailView;
